module.exports = __webpack_public_path__ + "img/retrofit-details-6.ef247c64.png";